import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface ElectronicMoneyPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const ElectronicMoneyPaymentSection: React.FC<ElectronicMoneyPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Código de Referencia"
        name="electronicMoneyVoucher"
        iconKey="payment" // puedes cambiar por otro icono si tienes uno para dinero electrónico
        type="text"
        placeholder="Ingrese el código de referencia"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default ElectronicMoneyPaymentSection;
